import React from 'react'
import { MarketingLabel, useDisclosure } from 'chemistry'
import { CashBackSidePanel } from './CashBackSidePanel'

export const MarketingLabelWithSidePanel = ({ labelText, metadata, actionData, sx }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <MarketingLabel
        labelText={labelText}
        metadata={metadata}
        sizes={['lg']}
        onClick={onOpen}
        sx={sx}
        id='Cashback-PDP-button'
      />
      <CashBackSidePanel isOpen={isOpen} onClose={onClose} actionData={actionData} />
    </>
  )
}
